import React, { memo } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { format, formatDistanceToNow } from 'date-fns';

export interface LastEditedInfo {
  by: string;
  at: string;
}

/** "Edited 2 hours ago by Ahmer", with the exact time on hover. Several teachers can share a subject's marks. */
const LastEdited = memo<{ value: LastEditedInfo | null | undefined }>(({ value }) => {
  if (!value) return null;
  const at = new Date(value.at);
  return (
    <Tooltip title={format(at, 'd MMM yyyy, h:mm a')} placement="bottom-start">
      <Typography variant="caption" color="text.secondary" noWrap component="div">
        Edited {formatDistanceToNow(at, { addSuffix: true })} by {value.by}
      </Typography>
    </Tooltip>
  );
});

LastEdited.displayName = 'LastEdited';

export default LastEdited;
